import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Ng2DeviceService } from 'ng2-device-detector';

import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { ImageViewModule } from '@blcloud/bl-ng-share-module';
import { UserLoginInfoResource } from '@blcloud/bl-ng-resource';

import { FaceDetectionModalComponent } from './face-detection-modal.component';
import { FaceDetectionModalService } from './face-detection-modal.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    BlNgCommonModule,
    BlNgUiComponentModule,
    ImageViewModule,
  ],
  exports: [
    FaceDetectionModalComponent,
  ],
  declarations: [
    FaceDetectionModalComponent,
  ],
  entryComponents: [
    FaceDetectionModalComponent,
  ]
})
export class FaceDetectionModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: FaceDetectionModalModule,
      providers: [
        UserLoginInfoResource,
        ImageViewModule.forRoot().providers,
        Ng2DeviceService,
        FaceDetectionModalService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/face-detection-modal/face-detection-modal.module.ts